import React from 'react';
import partial from 'lodash/partial';

import { TrackingIndexProvider } from '@/tracking';
import ContentChangeSuggestionApprovedNotification from '../ContentChangeSuggestionApprovedNotification';
import Notification from '../Notification';
import SubmitResultNotification from '../SubmitResultNotification';
import {
  SIMPLE_NOTIFICATION_ACTION,
  CONTENT_CHANGE_APPROVED_NOTIFICATION,
} from '../../constants';

import * as styles from './styles.module.css';

const NotificationListSection = ({
  header,
  notifications,
  onNotificationClick,
  submitResultEvents,
}) => {
  if (!notifications?.length && !submitResultEvents?.length) {
    return null;
  }

  return (
    <div>
      <div className={styles.listHeader}>{header}</div>
      <SubmitResultNotification
        submitResultEvents={submitResultEvents}
        onNotificationClick={partial(onNotificationClick, undefined)}
      />
      {notifications.map((n, index) => {
        const typename = n.action.__typename;
        if (typename === SIMPLE_NOTIFICATION_ACTION) {
          return (
            <TrackingIndexProvider index={index} key={n.id}>
              <Notification
                {...n}
                onClick={partial(onNotificationClick, n.id)}
              />
            </TrackingIndexProvider>
          );
        }
        if (typename === CONTENT_CHANGE_APPROVED_NOTIFICATION) {
          return (
            <TrackingIndexProvider index={index} key={n.id}>
              <ContentChangeSuggestionApprovedNotification
                notification={n}
                onClick={partial(onNotificationClick, n.id)}
              />
            </TrackingIndexProvider>
          );
        }
        return null;
      })}
    </div>
  );
};

export default NotificationListSection;
